import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import DataTable from '../Components/DataTable/DataTable';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Controllers from '../Api/Controllers';
import { FormCustom, Input, CheckBox, Select } from '../Components/Form/Form';
import Helpers from '../Helpers/Helpers';
import { toast as toastr } from 'react-toastify';
import JoditEditor from "jodit-react";
import ReactPlaceholder from 'react-placeholder';
import {useSelector} from 'react-redux'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const TypePurchaseForm = ({ data, onSubmit, viewDisabled }) => {
  const {
    id = '',
    description = '',
    justification = 0,
    template_award = '',
    template_business = '',
    template_certification_award = '',
    template_certification_business = '',
    template_act_purchase_order = '',
    id_unit = ''
  } = data

  const [row, setRow] = useState({
    id,
    description,
    justification: parseInt(justification) === 1,
    id_unit
  })
  const [executors, setExecutors] = useState([])
  const [isOk, setIsOk] = useState(false)

  const [templateAward, setTemplateAward] = useState(template_award)
  const [templateBusiness, setTemplateBusiness] = useState(template_business)
  const [templateCertificationAward, setTemplateCertificationAward] = useState(template_certification_award)
  const [templateCertificationBusiness, setTemplateCertificationBusiness] = useState(template_certification_business)
  const [templateActPurchaseOrder, setTemplateActPurchaseOrder] = useState(template_act_purchase_order)
  const dataSumbit = useCallback(() => {
    return {
      p_id: row.id,
      p_description: row.description,
      p_justification: row.justification ? 1 : 0,
      p_template_award: templateAward,
      p_template_business: templateBusiness,
      p_template_certification_award: templateCertificationAward,
      p_template_certification_business: templateCertificationBusiness,
      p_template_act_purchase_order: templateActPurchaseOrder,
    }
  }, [row, templateAward, templateBusiness, templateCertificationAward, templateCertificationBusiness, templateActPurchaseOrder])
  const editor = useRef(null)
  
  const [modalShowKeys, setModalShowKeys] = useState(false)

  useEffect(() => {
    Controllers.unit.get_unit_executors().then(res => {
      const opts = (res.data || []).map(r => ({ value: r.id, label: r.description }))
      setExecutors(opts)
      if (!row.id_unit && opts.length === 1) {
        setRow(prev => ({ ...prev, id_unit: opts[0].value }))
      }
    }).catch(() => { }).finally(() => setIsOk(true))
  }, [])

  return <ReactPlaceholder showLoadingAnimation rows={7} type='text' ready={isOk}>
    <FormCustom dataSubmit={dataSumbit()} onSubmit={({ e, dataSubmit }) => {
      if (!row.id_unit) {
        Helpers.toastr.construct({ response: 'warning', message: 'Seleccionar Unidad Ejecutora', toastr })
        return
      }
      onSubmit({ e, dataSubmit: { ...dataSumbit(), p_id_unit: row.id_unit } })
    }} viewSubmit={!viewDisabled}>
    <Input
      text="Descripción"
      placeholder="Descripción"
      classNameParent="col-12 mb-2"
      icon="far fa-comment-alt"
      required
      defaultValue={description}
      onChange={e => setRow({ ...row, description: e.currentTarget.value })}
      maxLength={255}
      disabled={viewDisabled}
    />
    <CheckBox
      text="Justificación"
      classNameParent="col-12 mb-2"
      checked={row.justification}
      onChange={e => setRow({ ...row, justification: e.currentTarget.checked })}
      id="justification-type-purchase"
      disabled={viewDisabled}
    />
    <Select
      text="Unidad Ejecutora"
      classNameParent="col-12 mb-2"
      icon="fa fa-building"
      options={executors}
      onChange={e => setRow({ ...row, id_unit: e ? e.value : '' })}
      isClearable
      disabled={viewDisabled || row.id !== ''}
      value={row.id_unit ? { value: row.id_unit, label: executors.find(e => parseInt(e.value) === parseInt(row.id_unit))?.label } : ''}
      required
    />
    <div className="col-12">
      <Button className="info" size="sm" onClick={() => setModalShowKeys(true)}><i className="fa fa-list mr-2"></i>Ver Claves</Button>
    </div>

    <div className="col-12">
      <p className="mt-2"><strong>Modelo Acta Adjudiación</strong></p>
      <JoditEditor
        required
        ref={editor}
        value={template_award}
        {...(viewDisabled ? {
          config: {
            readonly: true
          }
        } : {})}
        onChange={newContent => {
          setTemplateAward(newContent)
        }}
      />

      <p className="mt-4"><strong>Modelo Acta Negociación</strong></p>
      <JoditEditor
        required
        ref={editor}
        value={template_business}
        onChange={newContent => {
          setTemplateBusiness(newContent)
        }}
        {...(viewDisabled ? {
          config: {
            readonly: true
          }
        } : {})}
      />

      <p className="mt-4"><strong>Modelo Acta Certificación Adjudiación</strong></p>
      <JoditEditor
        required
        ref={editor}
        value={template_certification_award}
        onChange={newContent => {
          setTemplateCertificationAward(newContent)
        }}
        {...(viewDisabled ? {
          config: {
            readonly: true
          }
        } : {})}
      />

      <p className="mt-4"><strong>Modelo Acta Certificación Negociación</strong></p>
      <JoditEditor
        required
        ref={editor}
        value={template_certification_business}
        onChange={newContent => {
          setTemplateCertificationBusiness(newContent)
        }}
        {...(viewDisabled ? {
          config: {
            readonly: true
          }
        } : {})}
      />

      <p className="mt-4"><strong>Modelo Acta Orden de Compra</strong></p>
      <JoditEditor
        required
        ref={editor}
        value={template_act_purchase_order}
        onChange={newContent => {
          setTemplateActPurchaseOrder(newContent)
        }}
        {...(viewDisabled ? {
          config: {
            readonly: true
          }
        } : {})}
      />
    </div>

    <Modal show={modalShowKeys} onHide={() => setModalShowKeys(false)} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title as="div"><i className="fa fa-info mr-2"></i>Palabras Claves</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 d-flex flex-column">
        <span><i className="fa fa-check text-success mr-2"></i> [NRO_ACTA_ADJUDICACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [FECHA_ADJUDICACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [FECHA_ADJUDICACION_CORTA]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [HORA_ADJUDICACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [CANTIDAD_INICIAL]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [TIPO_INSUMO]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [DESCRIPCION_INTERNA]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [CODIGO_INTERNO]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [NOG]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [PROVEEDOR_GANADOR]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [NIT_GANADOR]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [IVA]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [JUSTIFICACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [CANTIDAD_ADJUDICADA]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [MONTO_ADJUDICADO]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [NRO_ACTA_NEGOCIACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [FECHA_NEGOCIACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [HORA_NEGOCIACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [CENTRO_COSTO_LETRA]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [PROVEEDORES_LETRA]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [CENTRO_COSTO]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [PROVEEDORES]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [RENGLON_JUSTIFICACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [CODIGO_PPR]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [DESCRIPCION_PPR]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [FOLIO_ADJUDICACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [FOLIO_NEGOCIACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [NRO_HOJAS]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [FECHA_GENERACION_CERTIFICACION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [FIRMAS]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [CARGO_SOLICITANTE]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [CARGO_AUTORIZADOR]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [NOMBRE_SOLICITANTE]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [NOMBRE_AUTORIZADOR]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [LIBRO]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [NOMBRE_PARTICIPANTE_COMISION]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [NOMBRE_PARTICIPANTE_SECRETARIA]</span>
        <span><i className="fa fa-check text-success mr-2"></i> [PO_DESCRIPCION]</span>
        </div>
      </Modal.Body>
    </Modal>
    </FormCustom>
  </ReactPlaceholder>
}

const TypePurchase = () => {
  const nameModulo = 'Tipos De Compra'
  const namePage = 'Tipo De Compra'
  const nameController = 'type_purchase'

  const [rows, setRows] = useState([]);
  const [isProcessing, setIsProcessing] = useState(true);
  const [modalSize, setModalSize] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [form, setForm] = useState('');
  const [reload, setReload] = useState(true);

  const permissions = useSelector(store => store.session.permissions)
  const actionsModule = Helpers.getActions({ permissions, name: 'tiposcompra' })


  useEffect(() => {
    if (reload) {
      Controllers[nameController]['get_' + nameController]().then(res => {
        setRows(res.data)
      })
      .finally(() => {
        setIsProcessing(false)
        setReload(false);
      });
    }
  }, [reload])

  const handleUpdate = useCallback(e => {
    const { id = '', disabled = 0 } = e.currentTarget.dataset;
    let button = e.currentTarget
    let buttonHTML = button.innerHTML;
    button.innerHTML = Helpers.icon.spin()
    
    setModalTitle(parseInt(disabled) === 1 ? <><i className={'mr-2 ' + actionsModule.view.icon}></i>{actionsModule.view.description} {namePage}</> : (id ? <><i className={'mr-2 ' + actionsModule.update.icon}></i>{actionsModule.update.description} {namePage}</> : <><i className={'mr-2 ' + actionsModule.create.icon}></i>{actionsModule.create.description} {namePage}</>))
    setModalSize('lg');
    setModalHeader('');

    Controllers[nameController]['get_' + nameController + '_id']({ p_id: id }).then(res => {
      setForm(<TypePurchaseForm data={res.data} onSubmit={onSubmit} viewDisabled={parseInt(disabled) === 1} />);
      setModalShow(true);
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
      setModalShow(false);
    }).finally(() => button.innerHTML = buttonHTML)
  }, [actionsModule])

  const onSubmit = ({ e, dataSubmit }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }

      if (dataSubmit.p_template_award === '' || dataSubmit.p_template_business === '' || dataSubmit.p_template_certification_award === '' || dataSubmit.p_template_certification_business === '') {
        Helpers.toastr.construct({ response: 'warning', message: 'Por favor, ingresar los datos completos', toastr })
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers[nameController][nameController + '_insert_update'](dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        setModalShow(false);
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
      setReload(true)
    });
  }

  const onDelete = e => {
    const { id = '' } = e.currentTarget.dataset;
    setModalTitle(<><i className="fa fa-trash mr-2"></i> Eliminar {namePage}</>);
    setModalHeader('bg-danger');
    setModalSize('sm');
    setForm(<div className="d-flex flex-column align-items-center">
      <p><strong>¿Eliminar {namePage} #{id}?</strong></p>

      <div>        
        <Button variant="danger" className="mr-2" size="sm" onClick={e => {
          let button = e.currentTarget
          let buttonHTML = button.innerHTML;
          button.innerHTML = Helpers.icon.spin()

          Controllers[nameController][nameController + '_delete']({
            p_id: id
          }).then(res => {
            Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
          }).catch(req => {
            Helpers.promise.catch({ req, toastr });
          }).finally(() => {
            button.innerHTML = buttonHTML;
            setReload(true)
            setModalShow(false);
          });
        }}>
          <i className="fa fa-check mr-2"></i>Si
        </Button>
        <Button variant="dark" className="mr-2" size="sm" onClick={() => setModalShow(false)}>
          <i className="fa fa-times mr-2"></i>No
        </Button>
      </div>
    </div>);
    setModalShow(true)
  }

  const dtRows = useMemo(() => {
    const thead = [
      { name: 'ID', align: 'center' },
      { name: 'Descripción' },
      { name: 'Justificación', align: 'center' },
      { name: 'Acc.', align: 'center' }
    ];

    return <DataTable
      isProcessing={isProcessing}
      tbody={rows}
      thead={thead}
      render={tbody => tbody.map(r => {
        let rowRender = [];

        rowRender.push(<td align={'center'}>{r.id}</td>);
        rowRender.push(<td align={'center'}>{r.description}</td>);
        rowRender.push(<td align={'center'}>
          <strong className={'text-' + (parseInt(r.justification) === 1 ? 'success': 'danger')}>
            {parseInt(r.justification) === 1 ? 'SI': 'NO'}
          </strong>
        </td>);

        rowRender.push(<td align={'center'}>
          {actionsModule.view ?  <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.view.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.view.color} data-disabled={1} size="xs" className="mr-1" data-id={r.id} onClick={handleUpdate}>
              <i className={actionsModule.view.icon}></i>
            </Button>
          </OverlayTrigger> : ''}
          {actionsModule.update ?  <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.update.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.update.color} size="xs" className="mr-1" data-id={r.id} onClick={handleUpdate}>
              <i className={actionsModule.update.icon}></i>
            </Button>
          </OverlayTrigger> : ''}
          {actionsModule.delete ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.delete.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.delete.color} size="xs" data-id={r.id} onClick={onDelete}>
              <i className={actionsModule.delete.icon}></i>
            </Button>
          </OverlayTrigger> : ''}
        </td>);
        return (<tr>
          {React.Children.toArray(rowRender)}
        </tr>);
      })}
    />
  }, [isProcessing, rows, handleUpdate, actionsModule])

  return <> 
    <Card>
      <Card.Header className="justify-content-between">
        <span>Listado De {nameModulo}</span>
        {actionsModule.create ? <Button onClick={handleUpdate} variant={actionsModule.create.color} size="sm"><i className={ actionsModule.create.icon}></i><span className="ml-2 d-none d-md-inline-block">{actionsModule.create.description} {namePage}</span></Button> : ''}
      </Card.Header>
      <Card.Body>
        {dtRows}
      </Card.Body>
    </Card>
    <Modal show={modalShow} onHide={() => setModalShow(false)} size={modalSize} backdrop="static">
      <Modal.Header closeButton className={modalHeader}>
        <Modal.Title as="div">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {form}
      </Modal.Body>
    </Modal>
  </>
}

export default TypePurchase;